import { render, staticRenderFns } from "./VehiclePlateCombobox.vue?vue&type=template&id=d01159ca"
import script from "./VehiclePlateCombobox.vue?vue&type=script&lang=js"
export * from "./VehiclePlateCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports